import { getDefaultTheme } from '@cvent/carina-tokens';
var tokens = getDefaultTheme();
export default {
    s: tokens.icon.size.s,
    m: tokens.icon.size.m,
    l: tokens.icon.size.l,
    xl: tokens.icon.size.xl
};
